<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WasteBinReadings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="wasteBinReadings"
    :headerTitle="'Waste Bin Readings'|gettext"
    :items="ds"
    export-to-csv
    :exportToCsvFilename="'waste-bin-readings'|pgettext('ExportFilename')"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    :contextMenu="b_2248226175642056_contextMenu"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @contextmenu:remove="evh_2248226175642056_contextmenuRemove($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="mx-2"
      >
        <ItpFormCheckbox
          name="skip_archived"
          :label="'Include handled readings'|pgettext('WasteBinReadings')"
          inline
          v-model="dsParams.include_worksheets"
        >
        </ItpFormCheckbox>
      </DIV>
      <ItpButton
        icon="fa-cog"
        :text="'Create Worksheets...'|gettext"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        variant="primary"
        class="mx-2"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-trash"
        :text="'Delete'|gettext"
        size="sm"
        variant="danger"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        class="mx-2"
        @click="evh_6705964765214521_click($event, {})"
      >
      </ItpButton>
      <PageHelp
        path="/assets/fixed-assets.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "wasteBinReadings",
    path: "/waste-bin-readings",
    component: "WasteBinReadings"
  }
)

@Component()
export default class WasteBinReadings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "WasteBinReadings.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_waste_bin_readings', { parameters: this.dsParams })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  b_2248226175642056_contextMenu!: any;
  dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns', 'b_2248226175642056_contextMenu'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        dsParams: {
          include_worksheets: false,
        }
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "timestamp",
          name: this.$fn.pgettext("WasteBinReadings", "Reading Time"),
          type: "command",
          formatter: {
            name: "chain",
            formatters: [{
              name: "datetime",
            }
              ,
            {
              name: "link",
              href: "#",
              className: "command-link",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "waste_bin_name",
          name: this.$fn.pgettext("WasteBinReadings", "Bin Name"),
          formatter: {
            name: "routeLink",
            to: "fixedAsset",
            params: {
              id: "waste_bin_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "waste_bin_number",
          name: this.$fn.pgettext("WasteBinReadings", "Bin Number"),
        }
          ,
        {
          field: "waste_bin_capacity",
          name: this.$fn.pgettext("WasteBinReadings", "Capacity (liters)"),
        }
          ,
        {
          field: "state",
          name: this.$fn.pgettext("WasteBinReadings", "State"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "gettext",
              context: "WasteBinReadingStates",
              conversion: "StartCase",
            }
              ,
            {
              name: "badge",
              variantmap: {
                empty: "success",
                full: "warning",
              }
              ,
              variantMapSource: "fieldValue",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental_name",
          name: this.$fn.pgettext("WasteBinReadings", "Rental"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "rental",
            params: {
              id: "rental_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_number",
          name: this.$fn.pgettext("WasteBinReadings", "Client Number"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_name",
          name: this.$fn.pgettext("WasteBinReadings", "Client Name"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "cycle",
          name: this.$fn.pgettext("WasteBinReadings", "Cycle"),
        }
          ,
        {
          field: "device_id",
          name: this.$fn.pgettext("WasteBinReadings", "Device ID"),
        }
          ,
        {
          field: "worksheets",
          name: this.$fn.pgettext("WasteBinReadings", "Worksheets"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "item",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "number",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "worksheet",
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        ]
        ,
        b_2248226175642056_contextMenu: {
          items: [{
            label: this.$fn.gettext("Delete"),
            command: "remove",
          }
            ,
          ]
          ,
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Waste Bin Readings"),
        icon: this.$config.wasteBin.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2008_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2008, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_2010_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_2010, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_2014_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_2014, alias=undefined
    return {
      grid: "wasteBinReadings",
    }
  }

  async act_2248226175642056_request_2012_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2248226175642056_request_2012, alias=undefined
    return {
      operation: "waste_bins/delete_reading",
      data: { identities: [$event.data.data.id] },
    }
  }

  async evh_2248226175642056_contextmenuRemove(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_contextmenuRemove.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_2016_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_2016, alias=showWasteBinReadingModal
    return {
      name: "WasteBinReadingModal",
      props: {
        objectId: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_2015_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_2015, alias=undefined
    return $event.data.column.id === 'timestamp'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_showModal_2018_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_2018, alias=undefined
    return {
      name: "CreateWorksheetsFromWasteBinReadingsModal",
      props: {
        readings: _.map(this.selectedItems, p => p.id),
      }
      ,
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_reloadSlickgrid_2022_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6705964765214521_reloadSlickgrid_2022, alias=undefined
    return {
      grid: "wasteBinReadings",
    }
  }

  async act_6705964765214521_request_2020_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6705964765214521_request_2020, alias=deleteItems
    return {
      operation: "waste_bins/delete_readings",
      data: { identities: this.selectedItems.map(p => p.id) },
    }
  }

  async act_6705964765214521_request_2020_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6705964765214521_request_2020, alias=deleteItems
    return {
      header: "_(\"Delete the selected readings?\")",
      message: this.$fn.gettext("This action cannot be undone."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_6705964765214521_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2008: actions.CloseModalAction;
    evh_7315092382398562_close_2007: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_2010: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_2009: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_2014: actions.ReloadSlickgridAction;
    evh_2248226175642056_success_2013: actions.EventHandlerImpl;
    act_2248226175642056_request_2012: actions.RequestAction;
    evh_2248226175642056_contextmenuRemove_2011: actions.EventHandlerImpl;
    evh_2248226175642056_contextmenuRemove: actions.EventHandlerGroup;
    act_2248226175642056_showModal_2016: actions.ShowModalAction;
    evh_2248226175642056_command_2015: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_8320016629450276_showModal_2018: actions.ShowModalAction;
    evh_8320016629450276_click_2017: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_6705964765214521_reloadSlickgrid_2022: actions.ReloadSlickgridAction;
    evh_6705964765214521_success_2021: actions.EventHandlerImpl;
    act_6705964765214521_request_2020: actions.RequestAction;
    evh_6705964765214521_click_2019: actions.EventHandlerImpl;
    evh_6705964765214521_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2008 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2008_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2007 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2008,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2007],
      }
    );
    const act_2248226175642056_setData_2010 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_2010_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_2009 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_2010,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_2009],
      }
    );
    const act_2248226175642056_reloadSlickgrid_2014 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_2014_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_success_2013 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_2014,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_request_2012 = new actions.RequestAction(
      {
        actionArgs: this.act_2248226175642056_request_2012_getActionArgs,
        events: [evh_2248226175642056_success_2013],
      }
    );
    const evh_2248226175642056_contextmenuRemove_2011 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_request_2012,
        event: "contextmenu:remove",
        displayName: "request",
      }
    );
    const evh_2248226175642056_contextmenuRemove = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_contextmenuRemove_2011],
      }
    );
    const act_2248226175642056_showModal_2016 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_2016_getActionArgs,
        displayName: "showWasteBinReadingModal",
        events: [],
      }
    );
    const evh_2248226175642056_command_2015 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_2016,
        event: "command",
        when: this.evh_2248226175642056_command_2015_getWhen,
        displayName: "showWasteBinReadingModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_2015],
      }
    );
    const act_8320016629450276_showModal_2018 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_2018_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_click_2017 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_2018,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_2017],
      }
    );
    const act_6705964765214521_reloadSlickgrid_2022 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6705964765214521_reloadSlickgrid_2022_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_success_2021 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_reloadSlickgrid_2022,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_6705964765214521_request_2020 = new actions.RequestAction(
      {
        actionArgs: this.act_6705964765214521_request_2020_getActionArgs,
        confirm: this.act_6705964765214521_request_2020_getConfirm,
        displayName: "deleteItems",
        events: [evh_6705964765214521_success_2021],
      }
    );
    const evh_6705964765214521_click_2019 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_request_2020,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_6705964765214521_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_click_2019],
      }
    );
    return {
      act_7315092382398562_closeModal_2008,
      evh_7315092382398562_close_2007,
      evh_7315092382398562_close,
      act_2248226175642056_setData_2010,
      evh_2248226175642056_selectedRowsChanged_2009,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_reloadSlickgrid_2014,
      evh_2248226175642056_success_2013,
      act_2248226175642056_request_2012,
      evh_2248226175642056_contextmenuRemove_2011,
      evh_2248226175642056_contextmenuRemove,
      act_2248226175642056_showModal_2016,
      evh_2248226175642056_command_2015,
      evh_2248226175642056_command,
      act_8320016629450276_showModal_2018,
      evh_8320016629450276_click_2017,
      evh_8320016629450276_click,
      act_6705964765214521_reloadSlickgrid_2022,
      evh_6705964765214521_success_2021,
      act_6705964765214521_request_2020,
      evh_6705964765214521_click_2019,
      evh_6705964765214521_click,
      showWasteBinReadingModal: act_2248226175642056_showModal_2016,
      deleteItems: act_6705964765214521_request_2020,
    }
  }
}

Vue.component("WasteBinReadings", WasteBinReadings);

</script>